export default __webpack_public_path__ + "static/media/GroupTermImage.8ff96a61.svg";